import firebase from "firebase/app";
import { v4 as uuidv4 } from "uuid";
import { storage } from "@/firebase";
import { imageTemplateCollection } from "@/firebase";

const state = {
  imageTemplate: [],
  imageFilteredTemplate: [],
  imageMultipleCanvasFilteredTemplate: [],
  filterSubTemplate: [],
  tempStartTemplateItemsArray: []
};

const getters = {};

const actions = {
  getImageTemplate({ commit }, payload) {
    return new Promise((resolve, reject) => {
      imageTemplateCollection
        .where("client", "==", payload.client)
        .where("module", "==", payload.module)
        //.where("private", "==", payload.private)
        .orderBy("order", "asc")
        .orderBy("title", "asc")
        //.limit(10)
        .get()
        .then((querySnapshot) => {
          let tempData = [];
          querySnapshot.forEach((doc) => {
            tempData.push(
              Object.assign(doc.data(), {
                id: doc.id,
                startFilter: payload.startFilter,
              })
            );
          });
          resolve(commit("getImageTemplate", tempData));
        })
        .catch(function (error) {
          reject(console.log("Error getting documents: ", error));
        });
    });
  },
  getFilteredImageTemplate({ commit }, payload) {
    //console.log(payload.code);
    return new Promise((resolve, reject) => {
      imageTemplateCollection
        .where("client", "==", payload.client)
        .where("module", "==", payload.module)
        //.where("private", "==", payload.private)
        .where("code", "in", payload.code)
        .orderBy("order", "asc")
        .orderBy("title", "asc")
        //.limit(10)
        .get()
        .then((querySnapshot) => {
          let tempData = [];
          // če ni zadetkov, pogledamo ali imamo morda template izven našega client-a (private=false)
          // sicer pa procesiramo normalno naše najdene template 
          if (querySnapshot.empty) {
            imageTemplateCollection
              .where("module", "==", payload.module)
              .where("private", "==", false)
              .where("code", "in", payload.code)
              .orderBy("order", "asc")
              .orderBy("title", "asc")
              //.limit(10)
              .get()
              .then((querySnapshot2) => {
                querySnapshot2.forEach((doc2) => {
                  tempData.push(Object.assign(doc2.data(), { id: doc2.id }));
                });
                if (payload.storeFiltered) {
                  resolve(commit("getFilteredImageTemplateAndStoreThem", tempData));
                } else resolve(commit("getFilteredImageTemplate", tempData));
              })
              .catch(function (error) {
                reject(console.log("Error getting documents: ", error));
              });
          } else {
            querySnapshot.forEach((doc) => {
              tempData.push(Object.assign(doc.data(), { id: doc.id }));
            });
            if (payload.storeFiltered) {
              resolve(commit("getFilteredImageTemplateAndStoreThem", tempData));
            } else resolve(commit("getFilteredImageTemplate", tempData));
          }
        })
        .catch(function (error) {
          reject(console.log("Error getting documents: ", error));
        });
    });
  },
  addImageTemplate({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.createdTimestamp = firebase.firestore.Timestamp.fromDate(
        new Date()
      );
      payload.editedTimestamp = firebase.firestore.Timestamp.fromDate(
        new Date()
      );

      payload.order = Number(payload.order); // String => Number
      payload.width = Number(payload.width); // String => Number
      payload.height = Number(payload.height); // String => Number

      const promises = [];

      if (payload.previewImage !== undefined) {
        let previewImageUploadPath =
          "imageTemplates/" + payload.client + "-" + uuidv4();

        payload.previewImageURL = previewImageUploadPath;
        let previewImageStorageRef = storage.ref(previewImageUploadPath);
        let previewImageUploadTask = previewImageStorageRef.put(
          payload.previewImage
        );
        promises.push(previewImageUploadTask);

        previewImageUploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
          complete: function () {
            previewImageUploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                payload.previewImage = downloadURL;
                console.log("previewImageURL created.");
              });
          },
        });
      } else payload.previewImage = "";

      Promise.all(promises).then(() => {
        console.log("Promises resolved.");
        setTimeout(() => {
          imageTemplateCollection
            .add(payload)
            .then((docRef) => {
              console.log("Added record.");
              resolve(
                commit(
                  "addImageTemplate",
                  Object.assign(payload, { id: docRef.id })
                )
              );
            })
            .catch((error) => {
              reject(console.log(error));
            });
        }, 2000);
      });
    });
  },
  removeImageTemplate({ commit }, payload) {
    return new Promise((resolve, reject) => {
      imageTemplateCollection
        .doc(payload)
        .delete()
        .then(() => {
          resolve(commit("removeImageTemplate", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  deleteImageFg({ commit }, payload) {
    payload.imageFg = "";
    payload.imageFgURL = "";

    payload.editedTimestamp = firebase.firestore.Timestamp.fromDate(new Date());
    payload.order = Number(payload.order); // String => Number

    imageTemplateCollection
      .doc(payload.id)
      .set(payload, { merge: true })
      .then(() => {
        console.log("Edited record.");
        commit("editImageTemplate", payload);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  saveImageTemplateRules({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.editedTimestamp = firebase.firestore.Timestamp.fromDate(
        new Date()
      );
      payload.order = Number(payload.order); // String => Number
      payload.width = Number(payload.width); // String => Number
      payload.height = Number(payload.height); // String => Number

      imageTemplateCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          console.log("Edited record.");
          resolve(commit("editImageTemplate", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  editImageTemplate({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.editedTimestamp = firebase.firestore.Timestamp.fromDate(
        new Date()
      );
      payload.order = Number(payload.order); // String => Number
      payload.width = Number(payload.width); // String => Number
      payload.height = Number(payload.height); // String => Number

      const promises = [];
      if (payload.previewImage !== undefined) {
        let previewImageUploadPath = "";
        if (payload.previewImage2.length <= 0) {
          // edit, prejšnje stanje brez slike (add v storage)
          previewImageUploadPath =
            "imageTemplates/" + payload.client + "-" + uuidv4();
          payload.previewImageURL = previewImageUploadPath;
        } else {
          // edit, prejšnje stanje s sliko (replace v storage)
          previewImageUploadPath = payload.previewImageURL;
        }

        delete payload.previewImage2;

        let previewImageStorageRef = storage.ref(previewImageUploadPath);
        let previewImageUploadTask = previewImageStorageRef.put(
          payload.previewImage
        );
        promises.push(previewImageUploadTask);

        previewImageUploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
          complete: function () {
            previewImageUploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                payload.previewImage = downloadURL;
                console.log("previewImageURL created.");
              });
          },
        });
      } else {
        if (payload.previewImage2.length <= 0) {
          // če slika ni izbrana in je prej tudi ni bilo nastavimo na ""
          payload.previewImage = "";
          payload.previewImageURL = "";
        } else {
          // če slika ni izbrana in je prej že bila v bazi, izbrišemo iz payloada, da se ne updejta
          delete payload.previewImageURL;
        }
        delete payload.previewImage2;
      }

      Promise.all(promises).then(() => {
        console.log("Promises resolved.");
        setTimeout(() => {
          imageTemplateCollection
            .doc(payload.id)
            .set(payload, { merge: true })
            .then(() => {
              console.log("Edited record.");
              resolve(commit("editImageTemplate", payload));
            })
            .catch((error) => {
              reject(console.log(error));
            });
        }, 2000);
      });
    });
  },
  // eslint-disable-next-line
  toggleImageTemplateBooleanActive({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.active = !payload.active;
      imageTemplateCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editImageTemplate", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  toggleImageTemplateBooleanPrivate({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.private = !payload.private;
      console.log("payload", payload);
      imageTemplateCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editImageTemplate", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
};

const mutations = {
  getImageTemplate(state, payload) {
    if (payload[0].startFilter.length > 0) {
      let t1 = payload[0].startFilter;
      console.log(t1);
      state.imageTemplate = payload.filter((x) =>
        payload[0].startFilter.includes(x.code)
      );
    } else {
      state.imageTemplate = payload;
    }
    //console.log(state.imageTemplate);
  },
  getFilteredImageTemplate(state, payload) {
    state.imageFilteredTemplate = payload;
    //console.log(state.imageFilteredTemplate);
  },
  getFilteredImageTemplateAndStoreThem(state, payload) {
    state.imageFilteredTemplate = payload;
    state.imageMultipleCanvasFilteredTemplate.push(payload);
    //console.log(state.imageMultipleCanvasFilteredTemplate);
  },
  addImageTemplate(state, payload) {
    state.imageTemplate.push(payload);
  },
  removeImageTemplate(state, payload) {
    const index = state.imageTemplate.findIndex((item) => item.id == payload);
    state.imageTemplate.splice(index, 1);
  },
  editImageTemplate(state, payload) {
    const index = state.imageTemplate.findIndex(
      (item) => item.id == payload.id
    );
    state.imageTemplate.splice(index, 1, payload);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
